<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="card-legend main-dashboard-wrap">
          <v-row>
            <v-col cols="12">
              <v-toolbar-title class="font-weight-bold color-white heading-content">
                Dashboard Category
              </v-toolbar-title>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-card
                max-width="400"
                class="bg-light-warning"
              >
                <div class="feature-body">
                  <div class="feature-icon">
                    <v-icon
                      size="45px"
                      color="orange darken-2"
                    >
                      mdi-handshake
                    </v-icon>
                  </div>
                  <div class="feature-title display-2 font-weight-bold orange--text">
                    InstaBuy
                  </div>
                </div>
                <v-card-actions>
                  <v-btn
                    color="orange"
                    text
                    @click="openPage('Insta Buy')"
                  >
                    Explore
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-card
                max-width="400"
                class="bg-light-primary"
              >
                <div class="feature-body">
                  <div class="feature-icon">
                    <v-icon
                      color="blue"
                      size="45px"
                    >
                      mdi-qrcode
                    </v-icon>
                  </div>
                  <div class="feature-title display-2 font-weight-bold blue--text">
                    QR Request
                  </div>
                </div>
                <v-card-actions>
                  <v-btn
                    color="blue"
                    text
                    @click="openPage('Qr Request')"
                  >
                    Explore
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Promise from '../../../lib/mixins/ExtendedPromises';
import Enquiry from '../../../repositories/enquiry';
  export default {
    name: 'MainDashboard',
    mixins: [Promise],
    data () {
      return {

      }
    },
    async created() {
    let rows = await Enquiry.get();
  },
    methods: {
      openPage (param) {
        this.$router.push({ name: `${param}` })
      },
    },
  }
</script>

<style lang="scss">
    .card-legend{
        background: white;
        box-shadow: 0 0 30px 0 rgba(82,63,105,.05);
        border-radius: 5px;
    }
    .main-dashboard-wrap{
        padding: 0 2rem;
        position: relative;
        z-index: 1;
        &:before{
            content: "";
            background: #e53135;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            height: 135px;
            z-index: -1;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
        }
    }
    .v-card{
        margin-top: 0;
    }
    .heading-content {
        color: white;
        padding-top: 1rem;
        letter-spacing: 2px;
    }
    .bg-light-warning {
        background-color: #fff4de!important;
    }
    .feature-body {
        padding: 1rem;
        .feature-icon{
            margin-bottom: 1rem;
        }
    }
    .bg-light-primary {
        background-color: #e1f0ff!important;
    }
    .bg-light-danger {
        background-color: #ffe2e5!important;
    }
    .bg-light-success {
        background-color: #c9f7f5!important;
    }
    .bg-light-blue2{
      background-color: #deffef!important;
    }
    .bg-light-purple{
       background-color: #e6dcee !important;
    }
    .feature-icon{
      min-height: 45px;
      .img-icon{
        img{
          width: 40px;
        }
      }
    }
    .blue2--text{
      color: #00e676!important;
    }
</style>
